module.exports = __webpack_public_path__ + "img/thumbnail_Wisent_j_normal.aea263f5.png";